'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-pure.js
// module id = 350
// module chunks = 22